import { render } from "./itemMs.vue?vue&type=template&id=4b0cb4d4"
import script from "./itemMs.vue?vue&type=script&lang=js"
export * from "./itemMs.vue?vue&type=script&lang=js"

import "./itemMs.vue?vue&type=style&index=0&id=4b0cb4d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__